module.exports = __webpack_public_path__ + "static/yarra_character_wishmastree_01-b94eb3dc5661d08d76a9bd5074c5db18.jpg";